import React from "react";
import { Pagination } from "@material-ui/lab";

import { withStyles } from '@material-ui/styles';

const MaterialPagination = withStyles((theme) => ({
  root: {
    paddingTop: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    "& .MuiPaginationItem-root": {
      color: theme.custom.pagination.itemColor,
    },
    "& .Mui-selected": {
      color: theme.custom.pagination.selectedColor,
      background: theme.custom.pagination.selectedBackground,
    }
  }
}))(Pagination);



export default MaterialPagination;
